/**
 * Copyright © Redbox Digital Limited. All rights reserved.
 */
define('Magento_Checkout/js/view/summary/basket',[
    'jquery',
    'matchMedia',
    'domReady!'
], function ($) {
    $.widget('tescomobile.basket', {
        /**
         * Widget initialization
         * @private
         */
        _create: function () {
            this.initStickyBasketSidebar();
            this.initBasketMediaCheck();
        },

        /**
         * Init sticky basket sidebar
         */
        initStickyBasketSidebar: function () {
            var self = this;
            mediaCheck({
                media: '(min-width: 1008px)',
                entry: function () {
                    if ($('.cart').length) {
                        var actionBar = $('.action-bar'),
                            cartIndex = $('.checkout-cart-index'),
                            cartContainer = $('.cart-container'),
                            cart = $('.cart'),
                            sideBar = $('.sidebar-additional'),
                            columnMain = $('.checkout-cart-index .column.main'),
                            collapsibleBlockTitle = $('.cart-summary .block.collapse div[data-role="title"]'),
                            stopPos = columnMain.outerHeight(true) - sideBar.outerHeight(true),
                            cartBottom = stopPos + $('.page-header').outerHeight(true) + $('.nav-sections').outerHeight(true) + $('.page-title-wrapper').outerHeight(true),
                            offset = cart.offset().top - actionBar.outerHeight(true),
                            requestFormTrigger = $('.cart-summary .accessible-format-form-wrapper .trigger-collapse'),
                            isRequestFormClicked = false;

                        requestFormTrigger.click(function () {
                            isRequestFormClicked = !isRequestFormClicked
                        })
                        collapsibleBlockTitle.click(function () {
                            if ($(this).parent().hasClass('active')) {
                                $('html, body').animate({
                                    scrollTop: $(this).offset().top - $(this).outerHeight(true) - $(this).next().outerHeight(true)
                                }, 500);
                            }
                        })
                        if(sideBar.outerHeight(true) > cartContainer.outerHeight(true)) {
                            stopPos = 0;
                            cartBottom = $('.page-header').outerHeight(true) + $('.nav-sections').outerHeight(true) + $('.page-title-wrapper').outerHeight(true) - 50;
                        }
                        cartIndex.removeClass('sticky-cart');
                        $(window).on('scroll', function () {
                            offset = cart.offset().top - actionBar.outerHeight(true);
                            // Block fixed to scroll with page
                            if ($(window).scrollTop() >= offset && !isRequestFormClicked) {
                                cartIndex.addClass('sticky-summary');
                                if ($('.page-wrapper').hasClass('_stickyheader')) {
                                    sideBar.css('top', actionBar.outerHeight(true) + $('.page-header').outerHeight(true));
                                } else {
                                    sideBar.css('top', actionBar.outerHeight(true));
                                }
                            } else {
                                cartIndex.removeClass('sticky-summary');
                                if ($('.page-wrapper').hasClass('_stickyheader')) {
                                    sideBar.css('top', actionBar.outerHeight(true) + $('.page-header').outerHeight(true));
                                } else {
                                    sideBar.css('top', actionBar.outerHeight(true));
                                }
                            }

                            // Stop block from moving down page in position
                            if ($(window).scrollTop() >= cartBottom && !isRequestFormClicked) {
                                cartIndex.addClass('sticky-stop');
                                sideBar.css('top', columnMain.outerHeight(true) - sideBar.outerHeight(true));
                            } else {
                                cartIndex.removeClass('sticky-stop');
                                if ($('.page-wrapper').hasClass('_stickyheader')) {
                                    sideBar.css('top', actionBar.outerHeight(true) + $('.page-header').outerHeight(true));
                                } else {
                                    sideBar.css('top', actionBar.outerHeight(true));
                                }
                            }
                        });
                    }
                },
                exit: function () {
                    if ($('.cart').length) {
                        var offset = $('.cart').offset().top,
                            cartIndex = $('.checkout-cart-index'),
                            item = $('.checkout-methods-items .item');

                        $('.sidebar-additional').css('top', '0');

                        $(window).on('scroll', function () {
                            if (self.btnInView('.checkout-methods-items')) {
                                animateDown(item);
                            } else {
                                if ($(window).scrollTop() >= offset) {
                                    animateUp(item);
                                } else {
                                    animateDown(item);
                                }
                            }
                        });

                        function animateUp(item, animationComplete) {
                            if (!cartIndex.hasClass('sticky-cart')) {
                                cartIndex.addClass('sticky-cart');
                                item.animate({'bottom': '-53px'}, 500);
                            }
                        }

                        function animateDown(item, animationComplete) {
                            if (cartIndex.hasClass('sticky-cart')) {
                                cartIndex.removeClass('sticky-cart');
                                item.animate({'bottom': '-160px'}, 500);
                            }
                        }
                    }
                }
            });
        },

        /**
         * @param elem
         * @return {boolean}
         */
        btnInView: function (elem) {
            if ($(elem).length > 0) {
                var scrollBottom = $(window).scrollTop() + $(window).height() - 80;
                return $(elem).offset().top - scrollBottom < $(elem).height();
            }
        },


        /**
         * Init basket mediacheck
         */
        initBasketMediaCheck: function () {
            var self = this;
            mediaCheck({
                media: '(min-width: 1008px)',
                entry: function () {
                    if(!$('.column.main .small-print-content').length) {
                        $('.small-print-content').appendTo('.column.main');
                    }
                },
                exit: function () {
                    if(!$('.sidebar-additional .small-print-content').length) {
                        $('.small-print-content').appendTo('.sidebar-additional');
                    }

                }
            });
        }
    });

    return $.tescomobile.basket;
});

